"use client";

import { getPasswordStrength } from "@health/validation";

type PasswordStrengthIndicatorProps = {
  password: string;
};

export function PasswordStrengthIndicator({ password }: PasswordStrengthIndicatorProps) {
  if (!password) return null;

  const { strength, label, color } = getPasswordStrength(password);

  return (
    <div className="flex items-center gap-2 px-2">
      <div className="flex-1 h-1 bg-white/20 rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-300 ${
            strength === 1
              ? "w-1/4 bg-red-400"
              : strength === 2
                ? "w-1/2 bg-yellow-400"
                : strength === 3
                  ? "w-3/4 bg-green-400"
                  : "w-full bg-green-400"
          }`}
        />
      </div>
      <span className={`text-xs ${color}`}>{label}</span>
    </div>
  );
}
